export default __webpack_public_path__ + "static/media/ascend_arena_2d.e9006839.png";